<div class="wm-view user-profile-token wm-subview webmate-default-theme">
  <div class="wm-topbar">
    <div class="wm-topbar-header">Share Report</div>
  </div>
  <div class="wm-card wm-profile-api-card">
    <form class="form">
      <div class="form-section">
        <div class="form-section-info">
          <h4>Create sharing link</h4>
          <div class="description">
            Create a new sharing link that can be used to access this report.
          </div>
        </div>
        <div class="form-section-content">
          <div class="form-item">
            <h4 class="form-label">Name <fa-icon [icon]="faQuestionCircle" pTooltip="Choose a name that reminds you what the link has been used for."></fa-icon></h4>
            <input type="text" pInputText placeholder="Sharing link name" class="name" name="name" [(ngModel)]="name">
            <div class="button-container">
              @if (!creatingNewToken) {
                <button pButton [disabled]="!name" label="Create new link" (click)="createSharingToken(name)"></button>
              }
              @if (creatingNewToken) {
                <button pButton [disabled]="true"  label="Create new link"><fa-icon icon="sync-alt" animation="spin" [fixedWidth]="true"></fa-icon></button>
              }
            </div>
          </div>
          @if (shareLink) {
            <div class="form-item">
              <h4 class="form-label">New sharing link</h4>
              <div class="sharelink-container">
                <input type="text" pInputText class="sharelink" [readonly]="true" [ngModel]="shareLink" [ngModelOptions]="{standalone: true}">
                @if (!copied) {
                  <fa-icon class="copy-icon clickable" icon="copy" size="lg" [fixedWidth]="true" pTooltip="Copy to clipboard" tooltipPosition="top" (click)="copyToken()"></fa-icon>
                }
                @if (copied) {
                  <fa-icon class="copy-icon" icon="check" size="lg" [fixedWidth]="true" pTooltip="Copied!" tooltipPosition="top"></fa-icon>
                }
              </div>
            </div>
          }
          <div class="form-item-info" [ngClass]="{'hidden': !shareLink}">Make sure to save your sharing link, you won't be able to access it again.</div>
        </div>
      </div>
      <div class="form-section last-section">
        <div class="form-section-info">
          <h4>Active sharing links</h4>
          <div class="description">
            These sharing links are currently valid. Delete them if they are not needed anymore.
          </div>
        </div>
        <div class="form-section-content">
          @if (loading && !idToBeDeleted) {
            <div class="token-table-status form-item">
              <p-progressSpinner></p-progressSpinner>
              <div class="loading-caption">Loading...</div>
            </div>
          }
          @if (!(loading && !idToBeDeleted) && sharingTokens.length === 0) {
            <div class="token-table-status form-item">
              You have no sharing links.
            </div>
          }
          @if (!(loading && !idToBeDeleted) && sharingTokens.length !== 0) {
            <div class="token-table form-item">
              <div class="token-table-row">
                <div class="name-column"><h4 class="form-label">Name</h4></div>
                <div class="date-column"><h4 class="form-label">Created</h4></div>
                <div class="delete-column"></div>
              </div>
              @for (token of sharingTokens; track token) {
                <div class="token-table-row">
                  <div class="name-column">{{token.name}}</div>
                  <div class="date-column">{{token.creationTime.substring(0, 10)}}</div>
                  <div class="delete-column">
                    @if (!idToBeDeleted || token.id !== idToBeDeleted) {
                      <button pButton class="p-button-text p-button-rounded" [disabled]="idToBeDeleted"  (click)="deleteSharingToken(token.id)" icon="true"><fa-icon icon="trash-alt" [fixedWidth]="true"></fa-icon></button>
                    }
                    @if (token.id === idToBeDeleted) {
                      <button pButton class="p-button-text p-button-rounded" [disabled]="true" icon="true"><fa-icon icon="sync-alt" animation="spin" [fixedWidth]="true"></fa-icon></button>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </form>
  </div>
</div>
